/*
 * @Author: your name
 * @Date: 2021-08-23 14:26:03
 * @LastEditTime: 2021-08-23 15:14:56
 * @LastEditors: Please set LastEditors
 * @Description: debounce
 * @FilePath: \contingency-manage\src\directives\debounce.js
 */

const debounce = {
  mounted(el, binding) {
    let time;
    el.addEventListener('click', () => {
      const callNow = !time;
      if (time) clearTimeout(time);
      time = setTimeout(() => {
        time = null;
      }, 1500);
      if (callNow) binding.value();
    });
  }
};
export default debounce;